import { useFlag } from '@rsos/flags';
import { useChatContext } from '../ChatContext';
import CollaboratorChat from './CollaboratorChat';
import CollaboratorChatHeader from './CollaboratorChatHeader';
import CollaboratorChatNext from './CollaboratorChatNext';
import { CollaboratorContainer } from './CollaboratorChatbox.styles';

const CollaboratorChatbox = () => {
  const { isCollapsed } = useChatContext();
  const hasTalkJSImprovements = useFlag('talkjs_improvements');

  return (
    <CollaboratorContainer
      data-name="conversations-container"
      flex={isCollapsed ? '0' : '1 1 100%'}
      height="100%"
    >
      <CollaboratorChatHeader />
      {hasTalkJSImprovements ? <CollaboratorChatNext /> : <CollaboratorChat />}
    </CollaboratorContainer>
  );
};

export default CollaboratorChatbox;
